module.exports = __webpack_public_path__ + "static/img/wealth.1a27418.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/wealth.gif
// module id = nZbe
// module chunks = 56